<template>
  <v-app>
    <!-- Renderiza el layout SOLO si hay token y no es la ruta de login -->
    <template v-if="showAppLayout">
      <TopBar @toggle-drawer="drawer = !drawer" />
      <NavDrawer v-model="drawer" />
      <v-main class="bg-grey-lighten-4">
        <v-container fluid>
          <router-view />
        </v-container>
      </v-main>
    </template>

    <!-- En login (o sin token) solo el <router-view/> -->
    <template v-else>
      <router-view />
    </template>
  </v-app>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { useLookupStore } from '@/stores/lookups'
import TopBar from '@/components/TopBar.vue'
import NavDrawer from '@/components/NavDrawer.vue'

const drawer = ref(false)
const route = useRoute()
const auth = useAuthStore()
const lookup = useLookupStore()

const isAuthed = computed(() => !!auth.token)
const isAuthPage = computed(() => route.name === 'login')
const showAppLayout = computed(() => isAuthed.value && !isAuthPage.value)

// Cierra el drawer al cambiar de ruta
watch(route, () => { drawer.value = false })

onMounted(async () => {
  // Asegura restaurar token antes de decidir layout/cargas
  if (auth.restoreFromStorage) await auth.restoreFromStorage()
  // Precarga catálogos SOLO si hay sesión
  if (isAuthed.value && lookup.departments.length === 0) {
    try { await lookup.load() } catch {}
  }
})
</script>
